import React from 'react'
import PrincipalInventoryMenuView from '../../containers/Inventory/PrincipalInventoryMenu'

const PrincipalInventoryMenu = () => {
    return (
        <PrincipalInventoryMenuView />
    )
}

export default PrincipalInventoryMenu